import React from 'react';
import { Text, TextProps } from 'react-native';
import { useCustomFontStyle } from '../../hooks/useCustomFontStyle';

export function LLText({ children, style: styleProp, ...props }: TextProps) {
  const styles = useCustomFontStyle({ style: styleProp });
  return (
    <Text style={styles} {...props}>
      {children}
    </Text>
  );
}
